import React, { useState , useEffect} from 'react';
import { Modal, Button } from 'react-bootstrap';
import Calendar from 'react-calendar';
import {SetCreateAttendanceRegularizationEmpAction ,setTheLeaveApplyDateUDS_employee, SetCalendarActions, setPayslipError} from "../../../Redux/Slice"
import 'react-calendar/dist/Calendar.css';
import { useDispatch, useSelector } from 'react-redux';

const AttendanceRegularizationTeampopu = (props) => {
    const { show, setShow, PageIndex, search, selectedIds , selectionMode } = props;
    const state = useSelector((state)=>state)
    const dispatch = useDispatch();
    const [selectedDates, setSelectedDates] = useState([]);
    const [nonSelectableDates, setNonSelectableDates] = useState([]);
    const [minDate] = useState(new Date(2020, 0, 1));
    const [fieldErrors, setFieldErrors] = useState({});
    const [purpose, setPurpose] = useState('');
    const formatDate = (inputDate) => {
        const date = new Date(inputDate);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    const [StateDate, setStateDate] = useState([]);
    const [fromDate, setFromdate] = useState({ from_date: "", to_date: "" });
    const [data, setData] = useState({
        continue_leave: false,
        from_date: "",
        to_date: "",
        status: "pending",
        notes: "",
        user_id: "",
        request_type: "request",
        leave_type: "",
      });
    
  

  function formatDateFields(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-indexed, so add 1
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  const processedDates = selectedDates.map((date, index) => {
    if (index % 2 === 0) {
      return { type: "from", date }; // Even index, treat as 'from date'
    } else {
      return { type: "to", date }; // Odd index, treat as 'to date'
    }
  });

  useEffect(() => {
    // Example usage:
    var Finaldate = [];

    if (selectedDates != null && selectedDates.length > 0) {
      selectedDates.map((item) => {
        const date = new Date(item);
        var formattedDate = formatDateFields(date);
        Finaldate.push({ value: formattedDate });
      });
      setStateDate(Finaldate);
    }
  }, [selectedDates]);


    const calendarResponse = useSelector(
        (state) => state.CalendarCall.CalendarData.data
      );
    
    useEffect(() => {
        const currentDate = new Date();
        const payload = {
          year: currentDate.getFullYear(),
          month: currentDate.getMonth() + 1,
        };
        dispatch(SetCalendarActions(payload));
      }, []);
    

    var applying = [state.UDSemployeeRoleActions.LeaveApplyedDate];
    useEffect(() => {
      if (calendarResponse != undefined && calendarResponse != null) {
        const dates = [];
  
        calendarResponse.map((item) => {
          console.log(item.date, "76iiututiiuiu");
  
          if (item.present) {
            dates.push({ fromdata: item.date, todate: null });
          } else if (item.weekoff) {
            console.log(item, "2384238oln d");
            dates.push({ fromdata: item.date, todate: null });
          } else if (item.working) {
            dates.push({ fromdata: item.date, todate: null });
          } else if (item.leave) {
            dates.push({ fromdata: item.date, todate: null });
          }
        });
        state.UDSemployeeRoleActions.LeaveApplyedDate.map((item) => {
          dates.push({ fromdata: item.fromdata, todate: item.todate });
        });
        dispatch(setTheLeaveApplyDateUDS_employee(dates)); /// here update the actions
      }
    }, []);
  
    useEffect(() => {
        const dates = state.UDSemployeeRoleActions.LeaveApplyedDate.flatMap(
          (item) => {
            const datesArray = [];
            if (item.fromdata) {
              datesArray.push(new Date(item.fromdata));
            }
            if (item.todate) {
              datesArray.push(new Date(item.todate));
            }
            return datesArray;
          }
        );
    
        // console.log("Non-selectable dates:", dates); // Debugging line to verify dates
        setNonSelectableDates(dates);
      }, [state]);
    
  const onChange = (date) => {
    const dateString = date.toDateString();
    fieldErrors.from_date = "";
    if (
      selectedDates.some(
        (selectedDate) => selectedDate.toDateString() === dateString
      )
    ) {
      // If the date is already selected, remove it from the array
      setSelectedDates(
        selectedDates.filter(
          (selectedDate) => selectedDate.toDateString() !== dateString
        )
      );
    } else {
      // If the date is not selected, add it to the array
      setSelectedDates([...selectedDates, date]);
    }
  };

    const handlePurposeChange = (event) => {
        setPurpose(event.target.value);
        setPayslipError("");
         let errors={}
        errors.purpose = '';
        setFieldErrors(errors);


        
    };
    useEffect(() => {
        if (StateDate) {
          const datesObject = {};
          if (StateDate.length == 2 || StateDate.length > 2) {
            // Sort StateDate by value (assuming StateDate is an array of objects with a 'value' property)
            StateDate.sort((a, b) => a.value.localeCompare(b.value));
    
            setFromdate({
              ...fromDate,
    
              from_date: StateDate[StateDate.length - 1].value,
              to_date: StateDate[0].value,
            });
          } else if (StateDate.length == 1) {
            // Handle case where StateDate is empty
            setFromdate({
              ...fromDate,
              from_date: StateDate[0].value, // Set default value for from_date when StateDate is empty
              to_date: null, // Set default value for to_date when StateDate is empty
            });
          }
        }
      }, [StateDate]);
      const handleDate = (inputDate, name) => {
        const value = formatDate(inputDate);
        setData((prev) => {
          return {
            ...prev,
            [name]: value,
          };
        });
      };

    const validateFields = () => {
        let errors = {};
        if (!selectedDates.length) {
            errors.from_date = 'Please select a date.';
        }
        if (!purpose.trim()) {
            errors.purpose = 'Purpose is required.';
        }
        setFieldErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFields()) {
            // Submit form logic
            console.log('Form submitted successfully', selectedIds, selectedDates, purpose);
            //   setShow(false); // Close the modal after submission
            const getMonYea = new Date(fromDate.from_date);


            const payload = {
                formData: {
                  to_date: fromDate.to_date,
                  date: fromDate.from_date,
                  status: "pending",
                  user_id: selectionMode =="single"?selectedIds[0]:selectedIds,
                  request_type: "request",
                  remarks: purpose,
                  selected_type: selectionMode,
                  month:getMonYea.getMonth()+1,
                  year:getMonYea.getFullYear(),
        
                },

                Requesttype: 2
        
              };
              dispatch(SetCreateAttendanceRegularizationEmpAction(payload));
              setShow(false)

        }
    };

    return (
        <>
            {/* Modal */}
            <Modal show={show} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Attendance Regularization</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <label
                                className="col-12 p-0"
                                htmlFor="to_date"
                                style={{ marginLeft: '19px' }}
                            >
                                You can also select from-to date based
                                <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="col-12 LeaveApplyCalendar">
                                <Calendar
                                    onClickDay={onChange}
                                    value={
                                        selectedDates.length
                                            ? selectedDates[selectedDates.length - 1]
                                            : new Date()
                                    }
                                    tileDisabled={({ date }) => date > new Date()} // Disables future dates globally
                                    minDate={minDate}
                                />
                            </div>
                        </div>

                        {fieldErrors.from_date && (
                            <span style={{ color: 'red' }}>{fieldErrors.from_date}</span>
                        )}

                        {/* Purpose Field */}
                        <div className="row mt-3">
                            <label
                                className="col-12 p-0"
                                htmlFor="purpose"
                                style={{ marginLeft: '19px' }}
                            >
                                Purpose
                                <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="col-12">
                                <input
                                    type="text"
                                    id="purpose"
                                    value={purpose}
                                    onChange={handlePurposeChange}
                                    className="form-control"
                                    placeholder="Enter purpose"
                                />
                            </div>
                        </div>

                        {fieldErrors.purpose && (
                            <span style={{ color: 'red' }}>{fieldErrors.purpose}</span>
                        )}

                        <Modal.Footer>
                          
                            <button
                                className=" btn CancelBtn"
                                style={{ background: "#F26639", color: "white" }}
                                onClick={() => setShow(false)}
                            >
                                Cancel
                            </button>
                            <button
                                class="CancelBtn btn"
                                type="submit"
                                style={{ background: "#ef4d39", color: "white" }}
                                onClick={handleSubmit}
                            >
                                Submit
                            </button>
                        </Modal.Footer>

                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AttendanceRegularizationTeampopu;
